import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskWorkflowConfigRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-workflow-scheme-config',
	path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
	exact: true,
};
